import { Box, Divider, Paper, Stack, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SettingsNav } from './SettingsNav';

export const SettingsLayout = (): React.JSX.Element => {
  const theme = useTheme();
  const isRow = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Paper variant={'outlined'} sx={{ width: '100%', overflow: 'hidden' }}>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'stretch'} sx={{ width: '100%' }}>
        <Box sx={{ flexShrink: 0, minWidth: { md: 240 }, py: 1 }}>
          <SettingsNav />
        </Box>
        <Divider orientation={isRow ? 'vertical' : 'horizontal'} flexItem />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Stack>
    </Paper>
  );
};
